import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const HZ_APP_URL = process.env.REACT_APP_HANDYZOOM_APP_URL;

// Every call goes through our backend, which relays it live to the HandyZoom app API.
export const api = axios.create({ baseURL: `${BACKEND}/api/hz`, withCredentials: true });

export const get = (url) => api.get(url).then((r) => r.data);
export const post = (url, body) => api.post(url, body).then((r) => r.data);
export const put = (url, body) => api.put(url, body).then((r) => r.data);
export const hzFile = (path) => `${BACKEND}/api/hz${path}`;

export const errMsg = (e, fallback = "Ha ocurrido un error") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "Revisa los datos del formulario";
  if (e?.response?.status >= 500) return "La app HandyZoom no responde ahora mismo. Inténtalo en unos minutos.";
  return fallback;
};

export const sendContact = (body) => axios.post(`${BACKEND}/api/contact`, body).then((r) => r.data);
